import * as React from 'react';
export default function useForceUpdate() {
  const [, forceUpdate] = React.useReducer(x => x + 1, 0);
  return forceUpdate;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/hooks/useForceUpdate.js
// module id = 444
// module chunks = 0